<template>
    <MasterTemplate 
        title="ข้อมูลสาขา" 
        itemKey="branchId"
        :headers="headers" 
        :setData="setData"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-text-field  outlined label="รหัสสาขา" placeholder=" " autofocus maxlength="20" v-model="editedItem.branchCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field outlined  label="ชื่อสาขา"  placeholder=" " maxlength="100" v-model="editedItem.branchName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-text-field outlined  placeholder=" " label="เลขประจำตัวเสียภาษี" maxlength="20" v-model="editedItem.taxId" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col col="8">
                    <v-select
                        label="บริษัท"
                        item-text="companyName"
                        item-value="companyCode"
                        v-model="editedItem.companyCode"
                        :items="companies"
                        :rules="[rules.required]"
                        outlined
                         placeholder=" "
                    >
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-text-field outlined  placeholder=" " label="ที่อยู่" maxlength="1000"  v-model="editedItem.address"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" >
                    <v-text-field outlined label="เวลาเข้างานช่วงเช้า" v-mask="'##:##'" placeholder="00:00"
                      v-model="editedItem.morningStartTime"
                      ></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined label="เวลาเลิกงานช่วงเช้า" v-mask="'##:##'" placeholder="00:00"  v-model="editedItem.morningEndTime"></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined label="เวลาเข้างานช่วงบ่าย" v-mask="'##:##'" placeholder="00:00"  v-model="editedItem.noonStartTime"></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined label="เวลาเลิกงานช่วงบ่าย" v-mask="'##:##'" placeholder="00:00"  v-model="editedItem.noonEndTime"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" >
                    <v-text-field outlined :rules="[rules.percent]" label="% เบิกประกัน(ซ่อมห้าง)" suffix="%"  placeholder="0-100"   v-mask="'###'" max v-model="editedItem.percentInsuranceMall"></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined :rules="[rules.percent]"  label="% เบิกประกัน(ซ่อมอู่)" suffix="%" placeholder="0-100"  v-mask="'###'" v-model="editedItem.percentInsuranceGarage"></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined :rules="[rules.percent]"  label="% เบิกเงินสด" suffix="%" placeholder="0-100"  v-mask="'###'" v-model="editedItem.percentCash"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" >
                    <v-text-field outlined :rules="[rules.percent]"  label="% เบิกภายใน" suffix="%" placeholder="0-100"  v-mask="'###'"  v-model="editedItem.percentInhouse"></v-text-field>
                </v-col>
                <v-col cols="3" >
                    <v-text-field outlined :rules="[rules.percent]"  label="% เครดิต" suffix="%" placeholder="0-100"  v-mask="'###'"  v-model="editedItem.percentCredit"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<style scoped>
    .text-right input  {
        text-align: right!important;
    }
</style>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listBranch, isExistBranchCode, insert, update, deleteBranch} from '@/api/master/branch-api.js'
import {listCompany} from '@/api/master/company-api.js'

export default {
    name: 'Branch',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสสาขาซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.branchCode': function(newVal, oldVal) {
            if (!this.editedItem.branchId) {
                this.editedItem.branchId = '-1';
            }
            if (newVal && this.editedItem.branchId) {
                isExistBranchCode(newVal, this.editedItem.branchId).then(response => {
                    this.isDup = response;
                }).catch(e => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'ชื่อบริษัท', value: 'companyName'},
            {text: 'รหัสสาขา', value: 'branchCode'},
            {text: 'ชื่อสาขา', value: 'branchName'},
            {text: 'เลขประจำตัวสียภาษี', value: 'taxId'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            branchId: '-1',
            branchCode: '',
            branchName: '',
            companyCode: '',
            taxId: '',
            tel: '',
            fax: '',
            address: '',
            morningStartTime: '',
            morningEndTime: '',
            noonStartTime: '',
            noonEndTime: '',
            percentInsuranceMall: '',
            percentInsuranceGarage: '',
            percentCash: '',
            percentInhouse: '',
            percentCredit: ''
        },
        companies: []
    }),
    methods: {
        listData() {
            return listBranch();
        },
        deleteData(item) {
            return deleteBranch(item.branchId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.branchName;
        },
        setData(item) {
            this.editedItem = item;
        },
        onOpenDialog() {
            listCompany().then(rs => {
                this.companies = rs;
            });
        }
    }
}
</script>